import {z} from 'zod';
import {ProtectionType} from '../../presentationProtection';

export const protectionSchema = z
    .object({
        _id: z.string().optional(),
        types: z.array(z.nativeEnum(ProtectionType, {message: 'Invalid presentation protection type'})),
        identificationLabel: z.string().optional(),
        password: z.string().optional(),
        validUntil: z.string().optional(),
        allowedIds: z.array(z.string()).optional(),
        allowedUsers: z.any().optional(),
    })
    .refine((data) => {
        if (data.types.includes(ProtectionType.IDENTIFICATION)) {
            return data.identificationLabel && data.identificationLabel.length > 0;
        }
        return true;
    })
    .refine(
        (data) => {
            if (data.types.includes(ProtectionType.PASSWORD)) {
                return data.password && data.password.length > 0;
            }
            return true;
        },
        {
            message: 'presEditPage.settings.presProtection.validationErrors.password',
            path: ['password'],
        }
    )
    .refine(
        (data) => {
            if (data.types.includes(ProtectionType.PASSWORD) && data.validUntil) {
                const validUntilDate = new Date(data.validUntil);
                const today = new Date();
                validUntilDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);
                return validUntilDate >= today;
            }
            return true;
        },
        {
            message: 'presEditPage.settings.presProtection.validationErrors.validUntil',
            path: ['validUntil'],
        }
    )
    .refine(
        (data) => {
            if (data.types.includes(ProtectionType.SELECTED_USERS)) {
                return data.allowedIds && data.allowedIds.length > 0;
            }
            return true;
        },
        {
            message: 'presEditPage.settings.presProtection.validationErrors.allowedUsers',
            path: ['allowedIds'],
        }
    );

export type PresentationProtectionFormType = z.infer<typeof protectionSchema>;
